
import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule, Http } from '@angular/http';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { IonicStorageModule } from '@ionic/storage';
import {
  GMapModule,
  DataTableModule,
  SharedModule,
  MultiSelectModule,
  CheckboxModule,
  TabViewModule } from 'primeng/primeng';
import { TableModule } from 'primeng/table';

import { SpeechRecognition } from '@ionic-native/speech-recognition';
import { TextToSpeech } from '@ionic-native/text-to-speech';
import { AndroidPermissions } from '@ionic-native/android-permissions';

import { HighchartsChartComponent } from './highcharts-chart.component';
import * as Highcharts from 'highcharts';
import * as HC_exporting from 'highcharts/modules/exporting';
HC_exporting(Highcharts);

import { MyApp } from './app.component';

import { HomePage } from '../pages/home/home';
import { LoginPage } from '../pages/login/login';
import { LogoutPage } from '../pages/logout/logout';
import { SignupPage } from '../pages/signup/signup';
import { PasswordResetPage } from '../pages/password-reset/password-reset';
import { WelcomePage } from '../pages/welcome/welcome';
import { PrivacyPage } from '../pages/privacy/privacy';
import { SupportPage } from '../pages/support/support';

import { MapPage } from '../pages/map/map';
import { LocationListPage } from '../pages/location-list/location-list';
import { LocationDetailPage } from '../pages/location-detail/location-detail';
import { LocationIrrigationPage } from '../pages/location-irrigation/location-irrigation';
import { LocationIrrigationRecordListPage } from '../pages/location-irrigation-record-list/location-irrigation-record-list';
import { LocationCarbohydratePage } from '../pages/location-carbohydrate/location-carbohydrate';
import { LocationEditPage } from '../pages/location-edit/location-edit';

import { ThinningDatasetEditPage } from '../pages/thinning-dataset-edit/thinning-dataset-edit';
import { ThinningDatasetDetailPage } from '../pages/thinning-dataset-detail/thinning-dataset-detail';
import { ThinningDatasetSummaryPage } from '../pages/thinning-dataset-summary/thinning-dataset-summary';
import { ThinningMeasurementList } from '../pages/thinning-measurement-list/thinning-measurement-list';
import { ThinningMeasurementDetailPage } from '../pages/thinning-measurement-detail/thinning-measurement-detail';
import { ThinningMeasurementExportPage } from '../pages/thinning-measurement-export/thinning-measurement-export';
import { ThinningMeasurementImportPage } from '../pages/thinning-measurement-import/thinning-measurement-import';

import { AboutThinningPage } from "../pages/about-thinning/about-thinning";
import { AboutIrrigationPage } from "../pages/about-irrigation/about-irrigation";
import { AboutIrrigationRecordsPage } from "../pages/about-irrigation-records/about-irrigation-records";
import { AboutCarbohydratePage } from "../pages/about-carbohydrate/about-carbohydrate";
import { AboutLocationsPage } from "../pages/about-locations/about-locations";
import { AboutLocationDetailsPage } from "../pages/about-location-details/about-location-details";
import { AboutSprayRecordsPage } from "../pages/about-spray-records/about-spray-records";
import { AboutMeasurementDetailPage } from "../pages/about-measurement-detail/about-measurement-detail";

import { SprayRecordListPage } from "../pages/spray-record-list/spray-record-list";
import { SprayRecordEditPage } from "../pages/spray-record-edit/spray-record-edit";

import { WaterHoldingReference } from "../pages/water-holding-reference/water-holding-reference"

import { Data } from '../providers/data';
import { Thinning } from '../providers/thinning';
import { Irrigation } from '../providers/irrigation';
import { Carbohydrate } from '../providers/carbohydrate';
import { Speech } from '../providers/speech';
import { ChartColors } from '../providers/chart-colors';

import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';

// import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
// import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { ChartModule } from 'angular2-chartjs';

import { AngularFireModule } from 'angularfire2';
import { AngularFirestore, AngularFirestoreCollection } from 'angularfire2/firestore';
// import { AngularFireOfflineModule } from 'angularfire2-offline';

import { AngularFireAuthModule } from 'angularfire2/auth';
import { AngularFireDatabaseModule } from 'angularfire2/database';

import { firebaseConfig } from "../../firebaseConfig"

// The translate loader needs to know where to load i18n files
// in Ionic's static asset pipeline.
// export function HttpLoaderFactory(http: Http) {
//   return new TranslateHttpLoader(http, './assets/i18n/', '.json');
// }


@NgModule({
  declarations: [
    MyApp,
    HomePage,
    LoginPage,
    LogoutPage,
    SignupPage,
    PasswordResetPage,
    WelcomePage,
    PrivacyPage,
    SupportPage,
    MapPage,
    LocationListPage,
    LocationDetailPage,
    LocationIrrigationPage,
    LocationIrrigationRecordListPage,
    LocationCarbohydratePage,
    LocationEditPage,
    ThinningDatasetEditPage,
    ThinningDatasetDetailPage,
    ThinningDatasetSummaryPage,
    ThinningMeasurementList,
    ThinningMeasurementDetailPage,
    ThinningMeasurementExportPage,
    ThinningMeasurementImportPage,
    SprayRecordListPage,
    SprayRecordEditPage,
    AboutThinningPage,
    AboutIrrigationPage,
    AboutIrrigationRecordsPage,
    AboutCarbohydratePage,
    AboutLocationsPage,
    AboutLocationDetailsPage,
    AboutSprayRecordsPage,
    AboutMeasurementDetailPage,
    WaterHoldingReference,
    HighchartsChartComponent
  ],
  imports: [
    BrowserModule,
    HttpModule,
    IonicModule.forRoot(MyApp, { build: '22-06-06' }),
    IonicStorageModule.forRoot(),
    ChartModule,
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    GMapModule,
    DataTableModule,
    TableModule,
    MultiSelectModule,
    CheckboxModule,
    TabViewModule,
    SharedModule
],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    LoginPage,
    LogoutPage,
    SignupPage,
    PasswordResetPage,
    WelcomePage,
    PrivacyPage,
    SupportPage,
    MapPage,
    LocationListPage,
    LocationDetailPage,
    LocationIrrigationPage,
    LocationIrrigationRecordListPage,
    LocationCarbohydratePage,
    LocationEditPage,
    ThinningDatasetEditPage,
    ThinningDatasetDetailPage,
    ThinningDatasetSummaryPage,
    ThinningMeasurementDetailPage,
    ThinningMeasurementExportPage,
    ThinningMeasurementImportPage,
    SprayRecordListPage,
    SprayRecordEditPage,
    AboutLocationsPage,
    AboutLocationDetailsPage,
    AboutThinningPage,
    AboutIrrigationPage,
    AboutIrrigationRecordsPage,
    AboutCarbohydratePage,
    AboutSprayRecordsPage,
    AboutMeasurementDetailPage
  ],
  providers: [
    Data,
    Thinning,
    Irrigation,
    Carbohydrate,
    Speech,
    ChartColors,
    SplashScreen,
    StatusBar,
    SpeechRecognition,
    TextToSpeech,
    AndroidPermissions,
    AngularFirestore,
    // Keep this to enable Ionic's runtime error handling during development
    { provide: ErrorHandler, useClass: IonicErrorHandler }
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts